/* Newsletter success: LINE friend addition only. */
(function () {
  'use strict';
  var destination = 'https://lin.ee/MaTg4dq';
  try { sessionStorage.removeItem('maruishi:newsletter-line:pending'); } catch (_) {}
  document.addEventListener('click', function (event) {
    var anchor = event.target && event.target.closest && event.target.closest('a[data-newsletter-line-link]');
    if (anchor) { anchor.href = destination; anchor.rel = 'noreferrer noopener'; }
  }, true);
  if (document.body && document.body.hasAttribute('data-newsletter-line-bridge')) {
    var button = document.getElementById('newsletter-line-open');
    if (button) button.href = destination;
    window.location.replace(destination);
  }
}());
